import { render, staticRenderFns } from "./PythagoreanTheoremViz.vue?vue&type=template&id=10b02d59&scoped=true"
import script from "./PythagoreanTheoremViz.vue?vue&type=script&lang=js"
export * from "./PythagoreanTheoremViz.vue?vue&type=script&lang=js"
import style0 from "./PythagoreanTheoremViz.vue?vue&type=style&index=0&id=10b02d59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b02d59",
  null
  
)

export default component.exports